<template>
	<c-dialog ref="dialog" width="600" mask-close>
		<div class="m-apply-body">
			<!-- 售后商品 -->
			<div class="m-apply-product">
				<div class="m-apply-product-info">
					<p class="m-apply-product-name">{{productText}}</p>
					<p class="m-apply-product-code">背贴码：{{product.produce_code || '-'}}</p>
				</div>
				<div class="m-apply-product-price">
					<p class="m-price">{{formatPrice(product.sale_price)}}</p>
					<p class="m-price-label">售出价</p>
				</div>
			</div>

			<div class="m-apply-form">
				<div class="m-apply-item">
					<label class="m-label"><span class="m-required">*</span> 售后方式</label>
					<div class="m-apply-type">
						<c-radio-group v-model="afterSaleType">
							<c-radio
								v-for="item in afterSaleTypeOptions"
								:key="item.value"
								:value="item.value"
							>{{item.name}}</c-radio>
						</c-radio-group>
					</div>
				</div>
				<div class="m-apply-item">
					<label class="m-label"><span class="m-required">*</span> {{afterSaleType == 1 ? '退款' : '补差'}}金额</label>
					<div class="m-apply-field">
						<c-input v-model="afterSaleAmount" type="number" decimal="2" :range="[0, 99999999]" placeholder="请输入售后金额" append-text="元"></c-input>
						<p v-if="maxRefundableAmount !== null" class="m-apply-tip">最多可退金额：{{formatPrice(maxRefundableAmount)}}</p>
					</div>
				</div>
				<div class="m-apply-item">
					<label class="m-label"><span class="m-required">*</span> 售后原因</label>
					<div class="m-apply-field">
						<c-input v-model="refundReason" type="textarea" placeholder="售后原因请写在这里....." maxlength="200"></c-input>
					</div>
				</div>
			</div>
		</div>

		<template #button>
			<c-button size="dialog" color="main" @click="submitHandle">确定</c-button>
			<c-button size="dialog" @click="closeDialog">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'saleAfterApply',

		data() {
			return {
				orderId: '',
				orderProductId: '',
				product: {},
				afterSaleType: 2,
				afterSaleAmount: '',
				refundReason: '',
				afterSaleTypeOptions: [{
					name: '补差',
					value: 2
				}, {
					name: '退机',
					value: 1
				}]
			}
		},

		computed: {
			/*********售后商品名称**********/
			productText() {
				var product = this.product || {};
				if (product.product_name) return product.product_name;
				var parts = [];
				if (product.brand_name) parts.push(product.brand_name);
				if (product.model_name) parts.push(product.model_name);
				if (product.color_name) parts.push(product.color_name);
				if (product.memory_name) parts.push(product.memory_name);
				return parts.join(' ') || '-';
			},

			/*********最多可退金额（列表行数据传入）**********/
			maxRefundableAmount() {
				var refundable = this.product.refundable_amount;
				if (refundable === null || refundable === undefined || refundable === '') return null;
				var amount = parseFloat(refundable);
				return isNaN(amount) ? null : amount;
			}
		},

		methods: {
			/*********打开弹框**********/
			open(data = {}) {
				this.orderId = data.orderId;
				this.orderProductId = data.orderProductId;
				this.product = data.product || {};
				this.afterSaleType = 2;
				this.afterSaleAmount = '';
				this.refundReason = '';
				this.$refs.dialog.open({title: '申请售后-线下订单'});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + (Math.round(parseFloat(price) * 100) / 100);
			},

			/*********提交申请**********/
			submitHandle() {
				var amount = parseFloat(this.afterSaleAmount);
				if (isNaN(amount) || amount <= 0) {
					this.$message({message: '售后金额必须大于0', type: 'warn'});
					return;
				}
				if (this.product.sale_price !== undefined && amount > parseFloat(this.product.sale_price)) {
					this.$message({message: '售后金额不能大于该明细售出价', type: 'warn'});
					return;
				}
				if (this.maxRefundableAmount !== null && amount > this.maxRefundableAmount) {
					this.$message({message: '售后金额不能超过最多可退金额：' + this.formatPrice(this.maxRefundableAmount), type: 'warn'});
					return;
				}
				if (!this.refundReason.trim()) {
					this.$message({message: '请输入售后原因', type: 'warn'});
					return;
				}
				this.request({
					url: '/aftersale/create',
					data: {
						order_id: this.orderId,
						order_product_id: this.orderProductId,
						after_sale_type: this.afterSaleType,
						after_sale_amount: amount,
						refund_reason: this.refundReason.trim()
					},
					loading: true,
					success: (data, msg) => {
						this.$message({message: msg || '售后申请提交成功', type: 'success'});
						this.$refs.dialog.close();
						this.$emit('resolve');
					}
				});
			},

			/*********关闭弹框**********/
			closeDialog() {
				this.$refs.dialog.close();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-apply-product {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 14px 28px;
		background: #edf2fe;

		.m-apply-product-name {
			font-size: 16px;
			color: #3d5eff;
		}

		.m-apply-product-code {
			margin-top: 6px;
			font-size: 13px;
			color: #333;
		}

		.m-apply-product-price {
			text-align: right;

			.m-price {
				font-size: 22px;
				font-weight: bold;
				color: #e53e3e;
			}

			.m-price-label {
				margin-top: 4px;
				font-size: 12px;
				color: #999;
			}
		}
	}

	.m-apply-form {
		padding: 24px 50px 40px;
	}

	.m-apply-item {
		margin-bottom: 24px;

		.m-label {
			display: block;
			margin-bottom: 8px;
			font-size: 14px;
			color: #333;

			.m-required {
				color: #f5222d;
				margin-right: 2px;
			}
		}
	}

	.m-apply-type {
		display: flex;
		gap: 14px;
	}

	.m-type-item {
		position: relative;
		width: 107px;
		height: 40px;
		line-height: 38px;
		text-align: center;
		font-size: 14px;
		color: #333;
		background: #f2f3f5;
		border: 1px solid #f2f3f5;
		border-radius: 4px;
		cursor: pointer;

		&.active {
			color: #3d5eff;
			background: #fff;
			border-color: #3d5eff;

			&:after {
				content: '';
				position: absolute;
				right: -1px;
				bottom: -1px;
				width: 0;
				height: 0;
				border-style: solid;
				border-width: 0 0 16px 16px;
				border-color: transparent transparent #3d5eff transparent;
			}

			&:before {
				content: '';
				position: absolute;
				right: 2px;
				bottom: 4px;
				width: 7px;
				height: 3px;
				border-left: 1px solid #fff;
				border-bottom: 1px solid #fff;
				transform: rotate(-45deg);
				z-index: 1;
			}
		}
	}

	.m-apply-field {
		.m-apply-tip {
			margin-top: 6px;
			font-size: 12px;
			color: #f5222d;
		}
	}
</style>
